// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { cronoszkEVM as _cronoszkEVM } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the cronoszkEVM chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 388
 * Chain Name: Cronos zkEVM Mainnet
 * Default Block Explorer: https://explorer.zkevm.cronos.org
 * Default RPC URL: https://mainnet.zkevm.cronos.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { cronoszkEVM } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: cronoszkEVM,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const cronoszkEVM = createCommon({
	..._cronoszkEVM,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
